window.eviivo = window.eviivo ? window.eviivo : {};
window.eviivo.auth = window.eviivo.auth ? window.eviivo.auth : {};

window.eviivo.auth.deviceFingerprint = function () {

    const getDeviceFingerprint = async function () {
        const { setOption, getFingerprint, getFingerprintData } = await import("@thumbmarkjs/thumbmarkjs");
        //use from here: https://www.thumbmarkjs.com/
        setOption('logging', false);

        // getting the fingerprint hash code and raw data after excluding some of the details
        setOption('exclude', ['webgl', 'audio', 'canvas', 'math', 'permissions']);
        setOption('timeout', 1500);

        let fingerprint = await getFingerprint(true);
        const data = { liteDetailsFingerprint: fingerprint.hash, liteDetailsRawData: fingerprint.data };
        return data;
    };

    return {
        getDeviceFingerprint
    }
}();

